<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               :title="title" size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData">
          <el-form-item>
            <span class="title1"><em class="f-red">*</em>工号:</span><el-input  type="textarea" autosize v-model="formData.engineerCode" size="small" style="width:9vw;" clearable/>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <span class="title1"><em class="f-red">*</em>更改为:{{}}</span>-->
<!--            <el-select v-model="formData.openFaceIdentify" readonly="true" style="width: 165px;">-->
<!--              <el-option label="禁用" :value="1" />-->
<!--              <el-option label="启用" :value="0" />-->
<!--            </el-select>-->
<!--          </el-form-item>-->
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute; bottom: 5px; right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="batchDepart">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import store from "@/store";
import api from "@/api/projectApi";
import duDialog from "@/views/dialogCommon/adminDialogByRole.vue";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import orderPop from "@/views/dialogCommon/radioOrderDialog.vue";
import {dictType, loadDictData} from "@/config/dictType";
import request from "@/router/axios";
import pager from "@/components/pager/index.vue";
import {indexPageMixins} from "@/mixins/tabChang";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'param', 'openFaceIdentify'],
  mixins: [indexPageMixins],

  created() {
    // this.dataId = this.param ? this.param.orderId ? this.param.orderId : '' : ''
    // this.showInRemark = this.param ? this.param.showInRemark ? this.param.showInRemark : '' : ''
    // this.orderRemarkData.id = this.param ? this.param.orderId ? this.param.orderId : '' : ''

    this.formData.openFaceIdentify = this.openFaceIdentify
    console.log("this.formData.openFaceIdentify", this.formData.openFaceIdentify)
    console.log("this.openFaceIdentify", this.openFaceIdentify)
    if (this.openFaceIdentify == 1) {
      this.title = "批量启用人脸识别";
    } else {
      this.title = "批量禁用人脸识别";
    }
  },
  mounted() {

  },
  components: {pager},
  computed: {
    api() {
      return api
    },
    idsLength() {
      this.formData.numuber =  this.ids.length;
      this.formData.ids = this.ids;
    },

    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },
  watch: {

  },
  data() {
    return {
      title: "批量更新人脸识别",
      type:null,
      dataId:null,
      formData: {
        engineerCode: '',
      },
      showOrderPop: false,

      drawer: true,


    }
  },
  methods: {

    batchDepart(){
      if(this.formData.engineerCode==''||this.formData.engineerCode==null){
        this.$message.error('请填写工号');
        return;
      }
      this.$http({
        url: api.snSiteEngineer.batchBatchUpdateFaceIdentify,
        method: 'post',
        data: {
          engineerCode : this.formData.engineerCode,
          openFaceIdentify: this.formData.openFaceIdentify
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$message({
          type: response.data.type,
          message: response.data.content
        });
        this.drawer = false;
        this.$emit('closeBatchDepart', 1)
        // this.reload()// 需要刷新页面
      })
    },

    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('closeBatchDepart', false)
    },

    handleClose() {
      this.drawer = false;
      this.$emit('closeBatchDepart', false)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
::v-deep .el-select>.el-input {
  width: 7vw;
}

::v-deep .el-input-number [role=button] {
  line-height: 26px;
  height: 26px;
  margin-top: 40px;
}
.el-input-number--medium {
  width: 200px;
  display: block;
  line-height: 34px;
}
.title1{
  display: inline-block;
  width: 120px;
  color: #72767b;
  font-size: 13px;
  text-align: end;
  margin: 5px 10px;
}
</style>
